import { ActionContext, Module } from 'vuex'
import { Campaign } from '../models'
import { CampaignState, RootState } from '../store/state_models'

export const campaigns: Module<CampaignState, RootState> = {
  namespaced: true,
  state: { campaigns: [], locationId: undefined },
  getters: {
    getById: (state: CampaignState) => {
      return (id: string) => state.campaigns.find(x => x.id === id)
    },
    getAll: (state: CampaignState) => {
      return state.campaigns
    }
  },
  mutations: {
    addUpdate: (state: CampaignState, payload: { campaigns: any, locationId: string }) => {
      state.campaigns = payload.campaigns
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    clearAll: (state: CampaignState) => {
      state.campaigns = []
      state.locationId = undefined
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<CampaignState, RootState>,
      locationId: string
    ) {
      if(!locationId) {
        context.commit('clearAll')
        return
      }


      if (context.state.locationId === locationId) {
        return context.state.campaigns;
      }

      context.commit('clearAll')
      return new Promise((resolve) => {

      Campaign.getQueryWithLocationId(
          locationId
        ).get().then(data => {
          context.commit('addUpdate', {
            locationId: locationId,
            campaigns: data.docs.map(d => {
              return {
                id: d.id,
                ...d.data()
              }
            })
          })
          resolve(context.state.campaigns.campaigns)
        }, err => {
          console.error(err)
          resolve(err)
        })
      })
    },
    async fetch(
      context: ActionContext<CampaignState, RootState>,
      locationId: string
    ) {
      if(!locationId) {
        context.commit('clearAll')
        return
      }

      console.log('fetching campaigns', locationId)

      try {
        const querySnapshot = await Campaign.getQueryWithLocationId(
          locationId
        ).get()
        const value = {
          locationId: locationId,
          campaigns: querySnapshot.docs.map(d => {
            return {
              id: d.id,
              ...d.data()
            }
          })
        }

        context.commit('addUpdate', value)

        return context.state.campaigns.campaigns
      } catch (err) {
        console.error(err)
        return
      }
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<CampaignState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<CampaignState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}